<template>
    <div>

        <section class="">
            <div class="container">

              <!--                  <p class="mb-3">-->
              <!--                    Enable, unleash, power, control, automation tool-->
              <!--                    Skippr has solved the complexities of integrations, schema changes, format optimisation, and scaling, event sourcing, exactly once semantics, event time handling, fault tolerance, scaling, PII, data optimisation and compaction... a mountain of engineering complexity and capex at your finger tips.-->
              <!--                  </p>-->

              <div class="row mt-40">

                <a href="#" v-on:click="clickEvent('perfect-data')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['fad', 'rocket-launch']" class="p1 fa-4x" />
<!--                    <font-awesome-icon :icon="['far', 'stopwatch']" class="p1 fa-4x" />-->
                  </figure>
                  <h3 class="">Perfect data in minutes not months</h3>
                  <p>
                    Integration, data prep and robust pipelines
                    <br />
                    Skippr does the grunt work, you do the glory
                  </p>
                </a>

                <a href="#" v-on:click="clickEvent('built-by-engineers')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['fal', 'hard-hat']" class="p1 fa-4x" />
                  </figure>
                  <h3 class="">Built by engineers for engineers</h3>
                  <p class="mb-3">

                    Skippr plays well with the rest of your stack. Drop into your CICD, integrate via API.
                  </p>

                </a>

                <a href="#" v-on:click="clickEvent('private-cloud')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['fad', 'lock']" class="p1 fa-4x" />
                  </figure>
                  <h3 class="">Deploy to your Private-Cloud</h3>
                  <p class="mb-3">
                    Skippr is your multi-cloud solution for data integration pipelines
                  </p>
                </a>
              </div>


              <div class="row mt-40">

                <a href="#" v-on:click="clickEvent('ui-api-cli')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['far', 'laptop-code']" class="p1 fa-4x" />
                    <!--                    <font-awesome-icon :icon="['far', 'stopwatch']" class="p1 fa-4x" />-->
                  </figure>
                  <h3 class="">Load through UI, API or CLI</h3>
                  <p>
                    Explore and configure via the UI, integrate
                    <br />
                    with the API.
                  </p>
                </a>

                <a href="#" v-on:click="clickEvent('schema-evolution')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['fal', 'search']" class="p1 fa-4x" />
                  </figure>
                  <h3 class="">Schema Discovery and Evolution</h3>
                  <p class="mb-3">
                    Support for new columns and data type changes. Schemas based on your actual data overtime.
                  </p>

                </a>

                <a href="#" v-on:click="clickEvent('nested-data')" class="core-feature col-lg-4 col-sm-6 col-12">
                  <figure class="mb-0">
                    <font-awesome-icon :icon="['fad', 'sitemap']" class="p1 fa-4x" />
                  </figure>
                  <h3 class="">Full Nested Data Support</h3>
                  <p class="mb-3">
                    Create data models on optimised nested data, in formats like Parquet and Arrow.
                  </p>
                </a>
              </div>

            </div>
        </section>

    </div>
</template>

<script>
    export default {
      name: 'GettingStarted',
      props: {
      },
      methods: {
        clickEvent(name) {
          this.$gtag.event('click', {
            event_category: 'features',
            event_label: name,
          })
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .core-feature a {
    text-decoration: none;
  }
</style>
